export default {
    // Header Section
    "discover_your": "మీ దాన్ని కనుగొనండి",
    "nakshatra": "నక్షత్రం",
    "birth_star_analysis": "జన్మ నక్షత్ర విశ్లేషణ",
    "nakshatra_description": `నక్షత్రం అనేది గ్రహణ వృత్తం వెంబడి ఉన్న 27 చంద్ర మండలాలలో ఒకటి, ప్రతి ఒక్కటి నాలుగు పాదాలుగా (చతుర్భాగాలుగా) విభజించబడుతుంది. ప్రతి పాదం నిర్దిష్ట అక్షరాలతో సంబంధం కలిగి ఉంటుంది, ఇది తరచుగా చంద్రుడి స్థానం ఆధారంగా నవజాత శిశువు పేరు ఎంచుకోవడానికి ఉపయోగించబడుతుంది.`,

    // Service Information
    "enter_birth_details": "మీ జన్మ వివరాలను నమోదు చేయండి",
    "complete_nakshatra_analysis": "పూర్ణ నక్షత్ర విశ్లేషణ",
    "service_price": "సేవా ధర",
    "comprehensive_nakshatra_analysis_note": "వ్యక్తిత్వం, సంబంధాలు మరియు జీవిత మార్గంపై మీ జన్మ నక్షత్రం ప్రభావం లోతైన అధ్యయనం",

    // Form Fields
    "full_name": "పూర్తి పేరు",
    "enter_full_name": "మీ పూర్తి పేరును నమోదు చేయండి",
    "email_address": "ఇమెయిల్ చిరునామా",
    "enter_email_address": "మీ ఇమెయిల్ చిరునామాను నమోదు చేయండి",
    "phone_number": "ఫోన్ నంబర్",
    "enter_phone_number": "మీ ఫోన్ నంబరును నమోదు చేయండి",
    "gender": "లింగం",
    "male": "పురుషుడు",
    "female": "స్త్రీ",
    "other": "ఇతర",
    "date_of_birth": "జన్మ తేదీ",
    "time_of_birth": "జన్మ సమయం",
    "exact_time_critical_for_nakshatra": "ఖచ్చితమైన నక్షత్ర గుర్తింపు కోసం సరైన జన్మ సమయం అవసరం",
    "place_of_birth": "జన్మ స్థలం",
    "place_of_birth_placeholder": "నగరం, రాష్ట్రం, దేశం",
    "preferred_language": "ప్రాధాన్య భాష",
    "english": "ఇంగ్లీష్",
    "hindi": "హిందీ",
    "telugu": "తెలుగు",
    "kannada": "కన్నడ",
    "language_note": "మీ నక్షత్ర విశ్లేషణ ఎంచుకున్న భాషలో అందించబడుతుంది",

    // Core Nakshatra Features
    "birth_star_identification": "జన్మ నక్షత్రం గుర్తింపు",
    "personality_traits_detailed": "వివరణాత్మక వ్యక్తిత్వ మరియు లక్షణ విశ్లేషణ",
    "compatibility_analysis": "వివాహ మరియు సంబంధ అనుకూలత",
    "career_guidance_nakshatra": "జన్మ నక్షత్రం ఆధారంగా కెరీర్ మార్గం",
    "lucky_elements": "అదృష్ట రంగులు, సంఖ్యలు మరియు రత్నాలు",
    "pdf_download": "సమగ్ర PDF నివేదిక",

    "what_you_get": "మీ నక్షత్ర విశ్లేషణలో ఉన్నవి",
    "your_birth_star_detailed": "మీ జన్మ నక్షత్రం వివరంగా",
    "nakshatra_characteristics": "ప్రధాన నక్షత్ర లక్షణాలు",
    "pada_analysis": "పాద (చతుర్భాగం) విశ్లేషణ",
    "ruling_deity_insights": "పాలక దేవత మరియు ఆధ్యాత్మిక అంతర్దృష్టులు",

    // Actions & Buttons
    "pay_and_generate_analysis": "నా నక్షత్ర విశ్లేషణ పొందండి",
    "processing_payment": "చెల్లింపును ప్రాసెస్ చేస్తోంది",
    "processing_request": "విశ్లేషణను రూపొందిస్తోంది",

    // Payment & Success Messages
    "thank_you": "ధన్యవాదాలు",
    "payment_successful": "చెల్లింపు విజయవంతం!",
    "nakshatra_analysis_processing": "మీ నక్షత్ర విశ్లేషణ మా నిపుణ వేద జ్యోతిష్యులచే తయారు చేయబడుతోంది. మీ జన్మ నక్షత్రం ప్రభావంపై లోతైన అంతర్దృష్టులు అందుకుంటారు.",
    "order_id": "ఆర్డర్ ID",
    "payment_id": "చెల్లింపు ID",
    "amount_paid": "చెల్లించిన మొత్తం",

    // Delivery Information
    "delivery_information": "డెలివరీ సమాచారం",
    "delivery_time": "విశ్లేషణ డెలివరీ",
    "within_12_hours_delivery_note": "మీ వివరణాత్మక నక్షత్ర నివేదిక 12 గంటలలోపు తయారవుతుంది",
    "whatsapp_notification": "వాట్సాప్ అప్‌డేట్‌లు",
    "whatsapp_delivery_note": "వాట్సాప్‌లో తక్షణ నోటిఫికేషన్‌లను అందుకోండి",
    "email_delivery": "ఇమెయిల్ డెలివరీ",
    "email_delivery_note": "పూర్తి విశ్లేషణ అందించబడుతుంది",

    // What You'll Receive
    "what_youll_receive": "మీ నక్షత్ర విశ్లేషణ ప్యాకేజ్",
    "detailed_nakshatra_report": "సమగ్ర నక్షత్ర నివేదిక (PDF)",
    "birth_star_characteristics": "జన్మ నక్షత్ర వ్యక్తిత్వ వివరణ",
    "pada_and_symbol_analysis": "పాద విశ్లేషణ మరియు పవిత్ర చిహ్నాలు",
    "compatibility_insights": "వివాహ మరియు భాగస్వామ్య అనుకూలత",
    "lucky_colors_numbers": "అదృష్ట అంశాలు మరియు పరిహార రత్నాలు",

    // Visual Content
    "sample_nakshatra_analysis": "నమూనా నక్షత్ర విశ్లేషణ",
    "sample_nakshatra_description": "వివరణాత్మక అంతర్దృష్టులతో మీ వ్యక్తిగత జన్మ నక్షత్ర విశ్లేషణ మునుజూపు",
    "popular_nakshatras": "27 నక్షత్రాలు",

    // Major Nakshatra Names
    "ashwini": "అశ్వినీ - గుర్రపు స్వారీలు",
    "bharani": "భరణీ - మోసేవాడు",
    "kritika": "కృతిక - కత్తిరించేవాడు",
    "rohini": "రోహిణీ - ఎర్రని దానం",
    "mrigashira": "మృగశిర - జింక తల",
    "ardra": "ఆర్ద్ర - తేమతో ఉన్న వాడు",
    "punarvasu": "పునర్వసు - పునరుద్ధరించేవాడు",
    "pushya": "పుష్య - పోషించేవాడు",
    "ashlesha": "ఆశ్లేష - కౌగిలించేవాడు",
    "magha": "మఘ - శక్తివంతుడు",
    "purva_phalguni": "పూర్వ ఫల్గుణి",
    "uttara_phalguni": "ఉత్తర ఫల్గుణి",

    // Status & Processing
    "your_nakshatra_analysis_status": "మీ నక్షత్ర విశ్లేషణ స్థితి",
    "processing_your_analysis": "మీ జన్మ నక్షత్రాన్ని విశ్లేషిస్తోంది",
    "analysis_processing_message": "మా వేద జ్యోతిష్య నిపుణులు మీ నక్షత్రం యొక్క కాస్మిక్ ప్రభావాలను అధ్యయనం చేస్తూ మీ వ్యక్తిగత అంతర్దృష్టులను తయారు చేస్తున్నారు.",
    "request_id": "విశ్లేషణ ID",
    "status": "స్థితి",
    "processing": "ప్రగతిలో ఉంది",
    "pending": "వేచి ఉంది",
    "email_notification_sent": "నిర్ధారణ ఇమెయిల్ పంపబడింది",
    "whatsapp_update_coming": "వాట్సాప్ అప్‌డేట్‌లు ప్రారంభించబడ్డాయి",
    "delivery_within_12_hours": "12 గంటలలోపు నివేదిక సిద్ధం",

    // Support & Contact
    "contact_support": "జ్యోతిష్య మద్దతును సంప్రదించండి",
    "need_help": "మార్గదర్శనం కావాలా?",
    "contact_us_at": "మమ్మల్ని సంప్రదించండి",

    // Error Messages
    "please_fill_all_required_fields": "దయచేసి అవసరమైన అన్ని జన్మ వివరాలను పూర్తి చేయండి",
    "payment_failed": "చెల్లింపు విఫలమైంది. దయచేసి మళ్లీ ప్రయత్నించండి.",
    "processing_failed": "విశ్లేషణ ప్రాసెసింగ్ విఫలమైంది. మా మద్దతు బృందాన్ని సంప్రదించండి.",

    // Nakshatra-Specific Elements
    "birth_star": "జన్మ నక్షత్రం",
    "nakshatra_lord": "నక్షత్ర స్వామి",
    "ruling_planet": "పాలక గ్రహం",
    "nakshatra_symbol": "పవిత్ర చిహ్నం",
    "presiding_deity": "పాలక దేవత",
    "gana_type": "గణ వర్గీకరణ",
    "nakshatra_nature": "సహజ స్వభావం",
    "power_animal": "శక్తి జంతువు",

    // Pada (Quarters) Analysis
    "pada_1": "మొదటి పాదం (0°-3°20')",
    "pada_2": "రెండవ పాదం (3°20'-6°40')",
    "pada_3": "మూడవ పాదం (6°40'-10°)",
    "pada_4": "నాలుగవ పాదం (10°-13°20')",
    "your_pada": "మీ నక్షత్ర పాదం",
    "pada_characteristics": "పాదం-నిర్దిష్ట లక్షణాలు",
    "pada_influence": "మీ పాదం మిమ్మల్ని ఎలా ఆకారపరుస్తుంది",

    // Personality & Character
    "core_personality": "ప్రధాన వ్యక్తిత్వ లక్షణాలు",
    "strengths_weaknesses": "బలాలు మరియు అభివృద్ధి రంగాలు",
    "mental_nature": "మానసిక వృత్తి",
    "emotional_patterns": "భావోద్వేగ నమూనాలు",
    "behavioral_tendencies": "ప్రవర్తనా ధోరణులు",
    "life_approach": "జీవితానికి దృక్పథం",

    // Compatibility & Relationships
    "compatible_nakshatras": "అత్యంత అనుకూలమైన జన్మ నక్షత్రాలు",
    "challenging_nakshatras": "సంభావ్య సవాలు కలిగించే మ్యాచ్‌లు",
    "marriage_compatibility": "వివాహ మరియు భాగస్వామ్య విశ్లేషణ",
    "friendship_compatibility": "మిత్రత్వ డైనామిక్స్",
    "business_partnership": "వ్యాపార సహకార సంభావ్యత",
    "relationship_advice": "సంబంధ మార్గదర్శనం",

    // Career & Profession
    "suitable_careers": "అనువైన కెరీర్ మార్గాలు",
    "professional_strengths": "వృత్తిపరమైన బలాలు",
    "work_environment": "అనువైన పని వాతావరణం",
    "leadership_style": "నాయకత్వ విధానం",
    "business_prospects": "వ్యవసాయ సంభావ్యత",
    "financial_tendencies": "డబ్బు నిర్వహణ శైలి",

    // Health & Wellness
    "health_tendencies": "ఆరోగ్య ధోరణులు",
    "vulnerable_areas": "శ్రద్ధ అవసరమైన ప్రాంతాలు",
    "wellness_recommendations": "ఆరోగ్యం మరియు క్షేమం చిట్కాలు",
    "dietary_guidance": "ఆహార సిఫార్సులు",

    // Spiritual & Remedial
    "spiritual_path": "ఆధ్యాత్మిక యాత్ర",
    "life_purpose": "ఆత్మ యొక్క ఉద్దేశ్యం",
    "karmic_lessons": "జీవిత పాఠాలు",
    "recommended_remedies": "వేద పరిహారాలు",
    "mantras_to_chant": "లాభదాయకమైన మంత్రాలు",
    "meditation_practices": "ధ్యాన పద్ధతులు",
    "worship_recommendations": "దేవత ఆరాధన మార్గదర్శనం",
    "fasting_days": "మంగళకరమైన ఉపవాస దినాలు",
    "donation_suggestions": "దాతృత్వ కార్యకలాపాలు",

    // Lucky Elements
    "lucky_colors": "మంగళకర రంగులు",
    "lucky_numbers": "అనుకూలమైన సంఖ్యలు",
    "lucky_days": "వారంలోని అత్యుత్తమ రోజులు",
    "lucky_directions": "అనుకూలమైన దిశలు",
    "lucky_gemstones": "లాభదాయకమైన రత్నాలు",
    "lucky_metals": "మంగళకరమైన లోహాలు",
    "favorable_timing": "ముఖ్యమైన కార్యకలాపాలకు అనువైన సమయం",

    // Detailed Analysis Sections
    "nakshatra_mythology": "పురాణ నేపథ్యం",
    "cosmic_connection": "కాస్మిక్ ప్రాధాన్యత",
    "elemental_influence": "మూలకార్ణ సంబంధాలు",
    "seasonal_connection": "కాలానుగత ప్రభావం",
    "lunar_mansion": "చంద్ర మండలం ప్రాధాన్యత",
    "vedic_wisdom": "పురాతన వేద అంతర్దృష్టులు"
};
